import * as Application from 'expo-application';
import { Platform } from 'react-native';
import { create } from 'zustand';
import { marquerNouveautesVues, marquerPolitiqueAnnoncee, nouveautesAMontrer, politiqueAAnnoncer } from '../services/nouveautes';

interface NouveautesState {
  /** À montrer dès que l'accueil est l'écran affiché (voir `AccueilAvecNouveautes`). */
  enAttente: boolean;
  /** Blocs de la version installée (offres, voix, langues). */
  versionAnnoncee: boolean;
  /** Bloc de la politique de confidentialité 1.12 (`politiqueAAnnoncer`). */
  politiqueAnnoncee: boolean;
  preparer: () => Promise<void>;
  fermer: () => Promise<void>;
}

/**
 * EN DÉVELOPPEMENT SEULEMENT : `EXPO_PUBLIC_FORCER_NOUVEAUTES=1` au lancement de Metro affiche la
 * fenêtre à chaque démarrage, quelles que soient la version et l'historique de l'appareil. `__DEV__`
 * vaut faux dans un build de production comme dans une mise à jour distante : le forçage n'y existe
 * pas.
 *
 * EXPO_PUBLIC_OPTIONNEL: absente, c'est le comportement normal (aucun forçage) ; rien à replier.
 */
export function nouveautesForcees(): boolean {
  return __DEV__ && process.env.EXPO_PUBLIC_FORCER_NOUVEAUTES === '1';
}

/**
 * Le web n'a pas de mise à jour à annoncer : il n'a pas de binaire, et sa version suit le déploiement.
 */
export const useNouveautesStore = create<NouveautesState>((set, get) => ({
  enAttente: false,
  versionAnnoncee: true,
  politiqueAnnoncee: false,
  preparer: async () => {
    if (nouveautesForcees()) {
      set({ enAttente: true, versionAnnoncee: true, politiqueAnnoncee: true });
      return;
    }
    if (Platform.OS === 'web') return;
    // Dans cet ordre : à la première installation, `nouveautesAMontrer` écrit la version vue, que
    // `politiqueAAnnoncer` lirait sinon comme la trace d'une installation antérieure.
    const politique = await politiqueAAnnoncer();
    const version = await nouveautesAMontrer(Application.nativeApplicationVersion ?? null);
    set({ enAttente: version || politique, versionAnnoncee: version, politiqueAnnoncee: politique });
  },
  fermer: async () => {
    const { versionAnnoncee, politiqueAnnoncee } = get();
    set({ enAttente: false });
    if (versionAnnoncee) await marquerNouveautesVues(Application.nativeApplicationVersion ?? null);
    if (politiqueAnnoncee) await marquerPolitiqueAnnoncee();
  },
}));
